import { render } from "./Payment.vue?vue&type=template&id=b5d1f094"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src996785304/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__